import { render } from "./FirstReserveInputPopUp.vue?vue&type=template&id=51d55c80"
import script from "./FirstReserveInputPopUp.vue?vue&type=script&lang=js"
export * from "./FirstReserveInputPopUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__